<template>
  <div class="container">
    <van-nav-bar
      :title="$lang['账户信息']"
      :left-text="$lang['返回']"
      @click-right="onClickRight"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="home-wrap">
      <div class="Avatar">
        <div class="avatar-area">
          <img src="@/assets/img/avatar.png" alt="" />
        </div>
        <div class="avarta-title">
          <!-- <span class="change-avar">更换头像</span> -->
        </div>
      </div>
      <div class="formInfo"></div>
    </div>
    <van-cell-group class="group">
      <van-field v-model="account" :disabled="true" label="用户名" />
      <van-field v-model="name" :disabled="true" label="姓名" />
    </van-cell-group>

    <van-cell-group class="group" v-if="isDisabled">
      <!-- 增加密码框 -->
      <van-field
        :disabled="true"
        v-model="newPassword"
        name="validator"
        label="密码"
      >
        <template #button>
          <van-button size="small" @click="passWordChange" center clearable
            >更改密码</van-button
          >
          <!-- <van-button v-else  size="small" @click="passWordSave" center  type="info">保存</van-button> -->
        </template>
      </van-field>
    </van-cell-group>
    <van-cell-group class="group" v-if="!isDisabled">
      <van-field v-model="newPassword" label="新密码" />
    </van-cell-group>

    <van-cell-group class="group" v-if="!isDisabled">
      <!-- 增加密码框 -->
      <van-field
        v-model="newPassword2"
        name="validator"
        label="新密码确认"
        :error-message="errMsg.password"
      >
        <template #button>
          <!-- <van-button v-if='isDisabled==true' size="small" @click="passWordChange" center clearable >更改密码</van-button> -->
          <van-button size="small" @click="passWordSave" center type="info"
            >保存</van-button
          >
        </template>
      </van-field>
    </van-cell-group>
  </div>
</template>

<script>
import { getUser, saveUser } from "@/api/apis";
export default {
  name: "my-setting",
  inject: ["reload"],

  components: {},
  meta: {},
  data() {
    return {
      errMsg: { password: "" },
      isDisabled: true,
      account: "",
      newPassword: "********",
      newPassword2: "",
      name: "",
      userId: "",
      img: require("@/assets/img/avatar.png"),
    };
  },
  methods: {
    // 保存密码正则校验
    validator(val) {
      return /^[a-zA-Z0-9_-]{6,18}$/.test(val);
    },
    passWordChange() {
      this.isDisabled = false;
      this.newPassword = "";
      console.log(this.userId);
    },
    passWordSave() {
      let data = {
        pwd: this.newPassword,
        account: this.account,
      };
      if (this.newPassword != this.newPassword2) {
        this.errMsg.password = "两次密码不一致";
        return;
      }

      if (this.newPassword.length < 6) {
        this.errMsg.password = "密码至少6位";
        return;
      }
      if (/^\d+$/.test(this.newPassword)) {
        this.errMsg.password = "密码请不要全部是数字";
        return;
      }

      this.$request.userChangepwd(data).then((res) => {
        if (res.code == 0) {
          if (this.isDisabled == false) {
            localStorage.removeItem("token");
            this.$toast.success({
              message: `${this.$lang["请重新登陆"]}`,
            });
            this.$router.push("/login");
          } else {
            this.$store.dispatch("syncUpdateUserInfo");
            this.$toast.success({
              message: "保存成功",
            });
          }
        }
      });
      console.log(this.isDisabled);
    },
    // 点击保存  保存个人信息--w
    onClickRight() {
      let userinfo = {
        name: this.name,
      };
      if (this.isDisabled != true) {
        userinfo.password = this.newPassword;
      }
      this.$request.saveUser(userinfo).then((res) => {
        if (res.code == 0) {
          if (this.isDisabled == false) {
            localStorage.removeItem("token");
            this.$toast.success({
              message: `${this.$lang["请重新登陆"]}`,
            });
            this.$router.push("/login");
          } else {
            this.$store.dispatch("syncUpdateUserInfo");
            this.$toast.success({
              message: "保存成功",
            });
          }
        }
      });
    },

    back() {
      this.$router.back(-1);
    },
  },
  created() {
    this.$nextTick(() => {
      console.log("eeeee");
      this.userId = this.$store.state.userId;
      this.account = this.$store.state.account;
      this.name = this.$store.state.name;
      
    });
  },
};
</script>

<style lang="less" scoped>
.container {
  .home-wrap {
    position: relative;
    background-color: rgb(255, 255, 255);
    padding-top: 15px;
    .Avatar {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      place-content: flex-start center;
      flex-shrink: 0;
      position: relative;
      align-items: center;
      .avatar-area {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-content: flex-start;
        flex-shrink: 0;
        position: relative;
        height: 120px;
        width: 120px;
        img {
          border-radius: 60px;
          width: 120px;
          height: 120px;
        }
      }
      .avarta-title {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-content: flex-start;
        flex-shrink: 0;
        position: relative;
        margin-top: 3px;
        height: 15px;
        span {
          box-sizing: border-box;
          display: block;
          font-size: 14px;
          white-space: pre-wrap;
          height: 15px;
          line-height: 15px;
          text-align: center;
          color: rgb(255, 80, 0);
        }
      }
    }
  }
  /deep/.van-nav-bar .van-icon {
    color: black;
  }

  /deep/.van-nav-bar__text {
    color: black;
  }

  .group {
    margin-bottom: 10px;
  }
}
</style>